import * as React from "react";

function SvgSuccess(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="83"
      height="83"
      viewBox="0 0 83 83"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.5 76.0834C60.5999 76.0834 76.0833 60.5999 76.0833 41.5C76.0833 22.4002 60.5999 6.91669 41.5 6.91669C22.4002 6.91669 6.91667 22.4002 6.91667 41.5C6.91667 60.5999 22.4002 76.0834 41.5 76.0834ZM24.2083 38.0417L17.2917 44.9584L34.5833 62.25L65.7083 31.125L58.7917 24.2084L34.5833 48.4167L24.2083 38.0417Z"
        fill="#4CAF50"
      />
    </svg>
  );
}

export default SvgSuccess;
